import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { LoanService } from '../loan/loan.service';

@Component({
    selector: 'app-vehicle-loan-calculation',
    template: `
        <ng-container *ngIf="priceValue">{{priceValue | defaultcurrency}}/md.</ng-container>
    `
})

export class VehicleLoanCalculationComponent implements OnInit, OnDestroy{
    @Input() objectPrice?: number | undefined;

    priceValue: number | undefined;

    private unsubscribe = new Subject<void>();

    constructor(
        private cdr: ChangeDetectorRef,
        private loanService: LoanService
    ) {}

    ngOnInit() {
        if (this.objectPrice) {
            this.loanService.getDefaultLoanPrice(this.objectPrice)
                .pipe(takeUntil(this.unsubscribe))
                .subscribe((loanData) => {
                if (loanData) {
                    this.priceValue = loanData.paymentPerMonth ? loanData.paymentPerMonth : undefined;
                }
                this.cdr.markForCheck();
            });
        }
    }

    ngOnDestroy(): void {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}